import { Card, CardActionArea, Typography, CardHeader, CardContent, CircularProgress } from "@mui/material";
import React, { useState } from "react";
import "./Notification.css";
import ClearIcon from '@mui/icons-material/Clear';
import { axiosFetch } from '../../../utils/AxiosFetch';
import { useNavigate } from "react-router";
import { notification_list } from '../../../redux/actions/notification.action';
import { useDispatch } from "react-redux";
import { SnackbarActions } from "../../../redux/actions/snackbar.actions";

function NotificationMessage(props) {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleRead = (id) => {
        var req = {
            "id": id.toString(),
            "isMarkAll": false
        };
        setLoading(true)
        axiosFetch({
            method: 'POST',
            url: `/Notifications/isread`,
            requestConfig: req,
        })
            .then((res) => {
                if (res.status === 200) {
                    dispatch(notification_list())
                    setLoading(false)
                }
                if (res.status === 400) {
                    setLoading(false);
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
                }
                if (res.status === 401) {
                    navigate("/");
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    return (
        <>
            {loading ?
                <CircularProgress sx={{ marginLeft: 20 }} size="2rem" /> :
                <Card sx={{ m: 1 }} className="notification-card">

                    {/* <CardActionArea > */}
                    {/* <Typography variant="h6" gutterBottom>
                        h6. Heading
                    </Typography> */}
                    <CardContent sx={{ m: 1 }}>
                        <ClearIcon fontSize="small" color="primary" sx={{ float: "right", cursor: "pointer" }} onClick={() => handleRead(props.notification.id)} />
                        <Typography variant="body2" gutterBottom>
                            {props.notification.message}
                        </Typography>
                    </CardContent>

                    {/* </CardActionArea> */}
                </Card>
            }
        </>

    )
}
export default NotificationMessage;